

const INITIAL_STATE = {
sell:[]
,
  google_login:{},
  facebook_login:{},
  cart:'',
  order:'',
  name:'HAssan',
  Item:[],
  shope:[]
 }
 export default (state = INITIAL_STATE, action) => {

  if(action.type=='google')
  {    return({
    ...state,
  google_login:action.payload,
    
  })
  
}


if(action.type=='facebook')
{    return({
  ...state,
  facebook_login:action.payload,
  
})

}
if(action.type=='Cart')
{   
   return({
  
  
...state,
cart:action.payload
  

         });

    }


    if(action.type=='kepper')
        {    return({
          
          
          ...state,
          shope:action.payload

        })
        
            }

        

        if(action.type=='RemoveMe')
        {    return({
          
          
          ...state,

        })
        
            }
      

            if(action.type==='Allshopping')
            {    return({
              ...state,
              
            Item:action.payload
            })
            
                }
                return state





              }